import { useEffect } from "react";
import { MF_EVENTS, } from "../../microfrontend/interfaces/microFrontend";
import { convertMessagesToChatMessages, isAccessTokenExpired, isHostMode, } from "../helpers";
import { HOST_MODES } from "@/constants";
import { useMainLayoutStore } from "../../zustand/mainLayoutStore";
import useProjectStore from "../../zustand/projectManagementStore";
import useAuthStore from "../../zustand/authStore";
import { updateUserChatAndHistory } from "./appLayoutUtilities";
import useToastStore from "../../zustand/toastStore";
import { getUserSession, postEmailNotify } from "@/core/api/api";
import { useAudioStore } from "@/shared/zustand/audioStore";
export const useMFCommunication = (deps) => {
    const { mfApi, 
    // streamingMessages,
    // setStreamingMessages,
    chatIdRef, updateArtifactIdInUrl, searchParams, setSearchParams, triggerFeedback, setChatResize, handleAddThisProject, setPersistInstantLearningData, triggerInstantLearningToSidebar, triggerForArtifact, } = deps;
    const { streamingMessages, setStreamingMessages, setModeFullScreen, modesHistory, currentHostMode, activeMode, isWidgetTypeChange, isCurrentHostChanged, remoteLoadedInfo, hostLoadedInfo, pendingArtifactData, pendingUserData, pendingSubModeData, pendingArtifactDataFromHost, setIsWidgetTypeChange, setIsCurrentHostChanged, setRemoteLoadedInfo, setPendingArtifactData, setPendingUserData, setHostLoadedInfo, setPendingArtifactDataFromHost, setPendingSubModeData, setCurrentHostMode, setModesHistory, setActiveMode, } = useMainLayoutStore();
    const { selectedProject, setSelectedProject } = useProjectStore();
    const { user } = useAuthStore();
    const showToast = useToastStore((state) => state.showToast);
    const { setAudioState } = useAudioStore();
    const dispatchMessage = (isStateChanged, loadedInfo, targetMode, streamingMessages, mfApi, isHost, selectedProject, user, setStateChanged) => {
        // Check if state has changed and if the mode is loaded
        if (!isStateChanged || !loadedInfo?.isLoaded) {
            return;
        }
        // Check if the loaded mode matches the target mode
        if (loadedInfo.isLoaded && loadedInfo.modeName !== targetMode) {
            console.log(`Waiting for ${isHost ? "host" : "remote"} to load as this particular mode is not yet opened`, loadedInfo);
            return;
        }
        const latestAudioBlob = useAudioStore.getState().audioState.originalAudio;
        // if(latestAudioBlob) downloadBlob(latestAudioBlob, `audio-recording-test.wav`);
        // Find the last user message
        if (streamingMessages.length > 0) {
            const lastMessage = [...streamingMessages]
                .reverse()
                .find((message) => message.role === "user");
            if (!lastMessage) {
                console.warn("No last message found");
                return;
            }
            if (mfApi) {
                const messagePayload = {
                    message: lastMessage?.content,
                    messageId: lastMessage?.id || "",
                    chatHistory: convertMessagesToChatMessages(streamingMessages),
                    projectId: selectedProject?._id || "",
                    userEmail: user?.email || "",
                    audioBlob: latestAudioBlob || null,
                };
                console.log(`Dispatching message payload from host to ${isHost ? "host" : "active widget"} mode:`, targetMode, messagePayload);
                mfApi.dispatch(targetMode, messagePayload);
                // Reset the state change flag if a setter was provided
                setStateChanged(false);
                // Reset the audioState as its use is done
                setAudioState((prev) => ({
                    ...prev,
                    originalAudio: null,
                }));
                // useAudioStore.setState({
                //   audioState: {
                //     isRecording: false,
                //     isPlaying: false,
                //     transcription: "",
                //     originalAudio: null,
                //     userHasStopped: false,
                //     pcm16: null,
                //     base64: null
                //   }
                // });
            }
        }
    };
    // dispatch message to remote mode
    useEffect(() => {
        dispatchMessage(isWidgetTypeChange, remoteLoadedInfo, activeMode, streamingMessages, mfApi, false, // isHost = false for remote
        selectedProject, user, setIsWidgetTypeChange);
    }, [isWidgetTypeChange, mfApi, remoteLoadedInfo]);
    // dispatch message to host mode
    useEffect(() => {
        dispatchMessage(isCurrentHostChanged, hostLoadedInfo, currentHostMode, streamingMessages, mfApi, true, // isHost = true for host mode
        selectedProject, user, setIsCurrentHostChanged);
    }, [isCurrentHostChanged, mfApi, hostLoadedInfo]);
    // commenting this out and making a generic function
    // dispatch message to remote mode
    // useEffect(() => {
    //   if (!isWidgetTypeChange || !remoteLoadedInfo?.isLoaded) {
    //     return;
    //   }
    //   if (remoteLoadedInfo.isLoaded && remoteLoadedInfo.modeName !== activeMode) {
    //     console.log(
    //       "Waiting for remote to load as this particular mode is not yet opened",
    //       remoteLoadedInfo
    //     );
    //     return;
    //   }
    //   if (streamingMessages.length > 0) {
    //     const lastMessage = [...streamingMessages]
    //       .reverse()
    //       .find((message) => message.role === "user");
    //     if (!lastMessage) {
    //       console.warn("No last message found");
    //       return;
    //     }
    //     if (mfApi) {
    //       const messagePayload: MessageRequest = {
    //         message: lastMessage?.content as string,
    //         messageId: lastMessage?.id || "",
    //         chatHistory: convertMessagesToChatMessages(streamingMessages),
    //         projectId: selectedProject?._id || "",
    //         userEmail: user?.email || "",
    //       };
    //       console.log(
    //         "Dispatching message payload from host to active widget:",
    //         activeMode,
    //         messagePayload
    //       );
    //       mfApi.dispatch(activeMode, messagePayload);
    //       setIsWidgetTypeChange(false);
    //       // setIsHostLoaded(false); // cancel the host load
    //     }
    //   }
    // }, [isWidgetTypeChange, mfApi, remoteLoadedInfo]);
    // // dispatch message to host mode
    // useEffect(() => {
    //   if (!isCurrentHostChanged || !hostLoadedInfo?.isLoaded) {
    //     return;
    //   }
    //   if (
    //     hostLoadedInfo.isLoaded &&
    //     hostLoadedInfo.modeName !== currentHostMode
    //   ) {
    //     console.log(
    //       "Waiting for host to load as this particular mode is not yet opened",
    //       hostLoadedInfo
    //     );
    //     return;
    //   }
    //   if (streamingMessages.length > 0) {
    //     const lastMessage = [...streamingMessages]
    //       .reverse()
    //       .find((message) => message.role === "user");
    //     if (!lastMessage) {
    //       console.warn("No last message found");
    //       return;
    //     }
    //     if (mfApi) {
    //       const messagePayload: MessageRequest = {
    //         message: lastMessage?.content as string,
    //         messageId: lastMessage?.id || "",
    //         chatHistory: convertMessagesToChatMessages(streamingMessages),
    //         projectId: selectedProject?._id || "",
    //         userEmail: user?.email || "",
    //       };
    //       console.log(
    //         "Dispatching message payload from host to host mode:",
    //         currentHostMode,
    //         messagePayload
    //       );
    //       mfApi.dispatch(currentHostMode, messagePayload);
    //       setIsCurrentHostChanged(false);
    //       // setIsRemoteLoaded(false); // cancel the remote load
    //     }
    //   }
    // }, [isCurrentHostChanged, mfApi, hostLoadedInfo]);
    const processSubModeRequest = (triggerModeName, eventType, subModeRequest) => {
        if (isHostMode(triggerModeName)) {
            console.log("its a host mode in trigger sub mode at event type ", eventType, " for mode ", triggerModeName);
            setCurrentHostMode(triggerModeName);
            setModesHistory((prev) => [
                ...prev,
                {
                    mode: triggerModeName,
                    openedBy: "triggerSubModeBy" + eventType,
                },
            ]);
            const latestHostLoadedInfo = useMainLayoutStore.getState().hostLoadedInfo;
            // switch off the previous host mode
            if (latestHostLoadedInfo?.isLoaded &&
                latestHostLoadedInfo.modeName !== triggerModeName) {
                setHostLoadedInfo({ isLoaded: false, modeName: "" });
            }
            if (latestHostLoadedInfo?.modeName !== triggerModeName ||
                (latestHostLoadedInfo.modeName === triggerModeName && !latestHostLoadedInfo.isLoaded)) {
                console.log(`${triggerModeName} Host not loaded yet at event type ${eventType}, storing user sub mode data ; hostLoadedInfo`, latestHostLoadedInfo);
                setPendingSubModeData({
                    modeName: triggerModeName,
                    eventType: eventType,
                    data: subModeRequest
                });
                return;
            }
            // else directly dispatch the subModeRequest to the host mode
            const transferSubModeReqPayload = {
                modeName: triggerModeName,
                eventType: eventType,
                data: subModeRequest
            };
            mfApi.dispatch(MF_EVENTS.TRANSFER_SUBMODE_REQUEST, transferSubModeReqPayload);
        }
        else {
            console.log("its a remote mode in trigger sub mode at event type ", eventType, " for mode ", triggerModeName);
            setActiveMode(triggerModeName);
            setModesHistory((prev) => [
                ...prev,
                {
                    mode: triggerModeName,
                    openedBy: "triggerSubModeBy" + eventType,
                },
            ]);
            // console.log("printing remoteLoadedInfo", remoteLoadedInfo);
            const latestRemoteLoadedInfo = useMainLayoutStore.getState().remoteLoadedInfo;
            // switch off the previous remote mode
            if (latestRemoteLoadedInfo?.isLoaded &&
                latestRemoteLoadedInfo.modeName !== triggerModeName) {
                setRemoteLoadedInfo({ isLoaded: false, modeName: "" });
            }
            if (latestRemoteLoadedInfo?.modeName !== triggerModeName ||
                (latestRemoteLoadedInfo.modeName === triggerModeName && !latestRemoteLoadedInfo.isLoaded)) {
                console.log(`${triggerModeName} Remote not loaded yet at event type ${eventType}, storing user sub mode data; remoteLoadedInfo`, latestRemoteLoadedInfo);
                setPendingSubModeData({
                    modeName: triggerModeName,
                    eventType: eventType,
                    data: subModeRequest
                });
                return;
            }
            // else directly dispatch the subModeRequest to the remote mode
            const transferSubModeReqPayload = {
                modeName: triggerModeName,
                eventType: eventType,
                data: subModeRequest
            };
            mfApi.dispatch(MF_EVENTS.TRANSFER_SUBMODE_REQUEST, transferSubModeReqPayload);
        }
        if (eventType === "previousMode" && subModeRequest.previousMode.artifactData && subModeRequest.previousMode.artifactData.id) {
            const urlObject = new URL(window.location.href);
            // then update the artifact in the url as well
            updateArtifactIdInUrl(subModeRequest.previousMode.artifactData, urlObject.searchParams, setSearchParams);
        }
    };
    // subscribe to remote & host events
    useEffect(() => {
        if (!mfApi) {
            console.warn("Host MicroFrontend API not initialized");
            return;
        }
        const unsubscribers = [];
        const remoteReadyUnsubscribe = mfApi.subscribe(MF_EVENTS.REMOTE_READY, (data) => {
            console.log("Received Remote ready data:", data);
            if (data.isLoaded) {
                setRemoteLoadedInfo({
                    modeName: data.modeName,
                    isLoaded: data.isLoaded,
                });
            }
        });
        unsubscribers.push(remoteReadyUnsubscribe);
        const processStatusUnsubscribe = mfApi.subscribe(MF_EVENTS.PROCESS_STATUS, async (status) => {
            console.log("Received status from remote:", status);
            if (status.messageType === "success") {
                const newMessage = {
                    id: status.messageId,
                    role: status.sender
                        ? status.sender === "user"
                            ? "user"
                            : "assistant"
                        : "assistant",
                    content: status.message,
                    time: status.time,
                    modeName: status.modeName,
                    isReadyToPersist: status.isReadyToPersist,
                    status: status.messageType,
                    artifactData: status.data?.artifactData,
                    additonalData: status.data?.additonalData,
                    isStreamEnd: status.isStreamEnd,
                };
                // Capture chatId in current scope
                const currentChatId = chatIdRef.current;
                setStreamingMessages((prevMessages) => {
                    let updatedMessages;
                    if ("isThinking" in status && !status.isThinking) {
                        const existingIdx = prevMessages.findIndex((msg) => msg.id === status.messageId);
                        updatedMessages =
                            existingIdx !== -1
                                ? prevMessages.map((msg, idx) => idx === existingIdx ? { ...msg, ...newMessage } : msg)
                                : [...prevMessages, newMessage];
                    }
                    else {
                        updatedMessages = [...prevMessages, newMessage];
                    }
                    // Updating artifact ID in URL
                    if (status.data?.artifactData) {
                        // console.log(
                        //   "Updating artifactId in URL from Success",
                        //   status.data.artifactData
                        // );
                        updateArtifactIdInUrl(status.data.artifactData, searchParams, setSearchParams);
                        //if loading is false for the artifact, replace that artifact
                        if (!status.data?.artifactData.isLoading) {
                            const newArtifactId = status.data?.artifactData.id ?? "";
                            // Find the object that has artifactData with the matching id
                            const matchedIdx = prevMessages.findIndex((message) => message.artifactData?.id === newArtifactId);
                            if (matchedIdx !== -1) {
                                updatedMessages = prevMessages.map((msg, idx) => idx === matchedIdx
                                    ? { ...msg, artifactData: status?.data?.artifactData }
                                    : msg);
                            }
                        }
                    }
                    // Use captured chatId
                    (async () => {
                        if (currentChatId) {
                            // console.log("calling put api in success case from RHS");
                            if (user && user.email) {
                                await updateUserChatAndHistory(user?.email, currentChatId, updatedMessages);
                            }
                        }
                        else {
                            console.warn("chat Id not found, so could not update chat history");
                        }
                    })();
                    return updatedMessages;
                });
            }
            else if (status.messageType === "loading" && status.isThinking) {
                setStreamingMessages((prevMessages) => {
                    const existingMessageIndex = prevMessages.findIndex((message) => message.id === status.messageId);
                    if (existingMessageIndex !== -1) {
                        return prevMessages.map((message, index) => index === existingMessageIndex
                            ? {
                                ...message,
                                artifactData: status.data?.artifactData,
                                content: status.thinkingResponse.content,
                                time: status.time,
                                orchestratorAndAgentsMessages: status.thinkingResponse.orchestratorAndAgentsMessages,
                                isStreamEnd: status.isStreamEnd,
                                role: status.sender
                                    ? status.sender === "user"
                                        ? "user"
                                        : "assistant"
                                    : "assistant",
                            }
                            : message);
                    }
                    return [
                        ...prevMessages,
                        {
                            id: status.messageId,
                            role: status.sender
                                ? status.sender === "user"
                                    ? "user"
                                    : "assistant"
                                : "assistant",
                            content: status.thinkingResponse.content,
                            time: status.time,
                            orchestratorAndAgentsMessages: status.thinkingResponse.orchestratorAndAgentsMessages,
                            artifactData: status.data?.artifactData,
                            isStreamEnd: status.isStreamEnd,
                        },
                    ];
                });
            }
            else {
                console.error("Process failed:", status.message);
                setStreamingMessages((prevMessages) => [
                    ...prevMessages,
                    {
                        id: status.messageId,
                        role: status.sender
                            ? status.sender === "user"
                                ? "user"
                                : "assistant"
                            : "assistant",
                        content: status.message,
                        time: status.time,
                        artifactData: status.data?.artifactData,
                        isStreamEnd: status.isStreamEnd,
                    },
                ]);
            }
        });
        unsubscribers.push(processStatusUnsubscribe);
        // Subscribe to project status updates
        const projectStatusUnsubscribe = mfApi.subscribe(MF_EVENTS.PROJECT_STATUS, (project) => {
            console.log("Received project status:", project);
            setSelectedProject(project);
            // setProject(project);
        });
        unsubscribers.push(projectStatusUnsubscribe);
        const feedbackTriggerUnsubscribe = mfApi.subscribe(MF_EVENTS.FEEDBACK_TRIGGER, (feedbackRequest) => {
            console.log("Received feedback trigger:", feedbackRequest);
            triggerFeedback(feedbackRequest);
        });
        unsubscribers.push(feedbackTriggerUnsubscribe);
        const chatResizeTriggerUnsubscribe = mfApi.subscribe(MF_EVENTS.CHAT_RESIZE_TRIGGER, (chatResizeRequest) => {
            console.log("Received chat resize trigger:", chatResizeRequest);
            setChatResize(chatResizeRequest?.chatResize);
        });
        unsubscribers.push(chatResizeTriggerUnsubscribe);
        const modeFullScreenTriggerUnsubscribe = mfApi.subscribe(MF_EVENTS.FULLSCREEN_MODE, //CHAT_RESIZE_TRIGGER,
        (modeFullScreenRequest) => {
            console.log("Received chat resize trigger:", modeFullScreenRequest);
            // setChatResize(chatResizeRequest?.chatResize);
            setModeFullScreen(modeFullScreenRequest?.modeFullscreen);
        });
        unsubscribers.push(modeFullScreenTriggerUnsubscribe);
        const addToProjectTriggerUnsubscribe = mfApi.subscribe(MF_EVENTS.ADD_TO_PROJECT, (addToProjectRequest) => {
            console.log("Received add to project trigger:", addToProjectRequest);
            handleAddThisProject();
        });
        unsubscribers.push(addToProjectTriggerUnsubscribe);
        const receiveInstantLearningDataUnsubscribe = mfApi.subscribe(MF_EVENTS.INSTANT_LEARNING_RECEIVE_TRIGGER, async (instantLearningReceiveRequest) => {
            console.log("Received instant learning trigger:", instantLearningReceiveRequest);
            setPersistInstantLearningData((prevData) => {
                return prevData.map((item) => {
                    if (item.id === instantLearningReceiveRequest.id) {
                        return {
                            ...item,
                            requestStatus: instantLearningReceiveRequest.requestStatus,
                            data: instantLearningReceiveRequest.data,
                        };
                    }
                    return item;
                });
            });
            if (instantLearningReceiveRequest.requestStatus === "success" &&
                instantLearningReceiveRequest.data) {
                // have to trigger the instant learning side bar
                triggerInstantLearningToSidebar(instantLearningReceiveRequest.data);
            }
            else {
                showToast("warn", "Warning", "Didn't receive data from remote");
            }
        });
        unsubscribers.push(receiveInstantLearningDataUnsubscribe);
        const artifactDataFileOpenUnsubscribe = mfApi.subscribe(MF_EVENTS.SHOW_ARTIFACT_DATA, async (artifactDataRequest) => {
            console.log("Received artifact Data in SHOW ARTIFACT DATA", artifactDataRequest);
            const isHost = Boolean(artifactDataRequest.modeName &&
                HOST_MODES[artifactDataRequest.modeName] !== undefined); // will tell is it remote or host
            // console.log("determining isHost",isHost)
            await triggerForArtifact(artifactDataRequest, false, isHost);
        });
        unsubscribers.push(artifactDataFileOpenUnsubscribe);
        const notifyEmailTriggerUnsubscribe = mfApi.subscribe(MF_EVENTS.EMAIL_NOTIFICATION_TRIGGER, async (emailNotificationRequest) => {
            console.log("Received email notification trigger:", emailNotificationRequest);
            if (user && user.email && user.provider.name) {
                const emailPayload = {
                    request_id: emailNotificationRequest.request_id,
                    send_email: emailNotificationRequest.send_email,
                    user_email: user?.email,
                    completion_percentage: emailNotificationRequest.completion_percentage,
                    task_name: emailNotificationRequest.task_name,
                    user_name: user.provider.name,
                    task_url: emailNotificationRequest.task_url,
                    next_steps: emailNotificationRequest.next_steps,
                };
                const { responseData, error } = await postEmailNotify(emailPayload);
                if (error) {
                    showToast("error", "Error", error.errorMessage);
                    console.log("Error in sending email notification", error);
                    return;
                }
                else if (responseData) {
                    showToast("success", "Success", `We will send you an email when ${emailNotificationRequest.task_name} is done`);
                    console.log("Email notification sent successfully", responseData);
                    return;
                }
            }
            else
                showToast("warn", "Warning", "User details not found");
        });
        unsubscribers.push(notifyEmailTriggerUnsubscribe);
        const userDetailsTriggerUnsubscribe = mfApi.subscribe(MF_EVENTS.GET_USER_DETAILS, async (userDetailsRequest) => {
            console.log("Received user Details Request trigger:", userDetailsRequest);
            const user = useAuthStore.getState().user;
            const setUser = useAuthStore.getState().setUser;
            if (user) {
                if (user?.provider.expires_at &&
                    !isAccessTokenExpired(user?.provider?.expires_at?.toString(), 45)) {
                    // we have to check wether the mode is loaded or not
                    if (remoteLoadedInfo?.modeName !== userDetailsRequest?.modeName ||
                        (remoteLoadedInfo.modeName === userDetailsRequest?.modeName &&
                            !remoteLoadedInfo.isLoaded)) {
                        console.log(`${userDetailsRequest.modeName} Remote not loaded yet, storing user data; remoteLoadedInfo`, remoteLoadedInfo);
                        setPendingUserData({
                            modeName: userDetailsRequest?.modeName,
                            userData: user,
                        });
                        return;
                    }
                    else {
                        mfApi.dispatch(MF_EVENTS.RECEIVE_USER_DETAILS, user);
                    }
                }
                else {
                    const { responseData, error } = await getUserSession();
                    if (error) {
                        console.error("error in getting session", error);
                        showToast("error", "Error", "Error in getting session, check console for more details.");
                    }
                    else {
                        if (responseData) {
                            if (responseData?.user) {
                                // we have to check wether the mode is loaded or not
                                if (remoteLoadedInfo?.modeName !==
                                    userDetailsRequest?.modeName ||
                                    (remoteLoadedInfo.modeName ===
                                        userDetailsRequest?.modeName &&
                                        !remoteLoadedInfo.isLoaded)) {
                                    console.log(`${userDetailsRequest.modeName} Remote not loaded yet, storing user data; remoteLoadedInfo`, remoteLoadedInfo);
                                    setPendingUserData({
                                        modeName: userDetailsRequest?.modeName,
                                        userData: responseData?.user,
                                    });
                                    return;
                                }
                                else {
                                    mfApi.dispatch(MF_EVENTS.RECEIVE_USER_DETAILS, responseData?.user);
                                }
                                setUser(responseData?.user);
                                // setUser(responseData?.user);
                                // mfApi.dispatch(
                                //   MF_EVENTS.RECEIVE_USER_DETAILS,
                                //   responseData.user
                                // );
                            }
                            else {
                                console.error("error in getting session", error);
                                showToast("error", "Error", "Error in getting session, check console for more details.");
                            }
                        }
                    }
                }
            }
            else {
                console.warn("User is not logged in.");
            }
        });
        unsubscribers.push(userDetailsTriggerUnsubscribe);
        const subModeTriggerUnsubscribe = mfApi.subscribe(MF_EVENTS.TRIGGER_SUBMODE, async (subModeRequest) => {
            console.log("Received user sub mode trigger:", subModeRequest);
            if (!mfApi) {
                showToast("error", "Error", "MF API not found");
                return;
            }
            let triggerModeName = "";
            if (subModeRequest.eventType === "modeToTrigger") {
                if (subModeRequest.modeToTrigger.modeName.length > 0) {
                    triggerModeName = subModeRequest.modeToTrigger.modeName;
                    processSubModeRequest(triggerModeName, subModeRequest.eventType, subModeRequest);
                }
                else {
                    console.warn("Mode name not found in subModeRequest at event type ", subModeRequest.eventType, " for mode ", subModeRequest);
                    showToast("warn", "Warning", "Mode name not found in subModeRequest");
                    return;
                }
            }
            else if (subModeRequest.eventType === "previousMode") {
                if (subModeRequest.previousMode.modeName.length > 0) {
                    triggerModeName = subModeRequest.previousMode.modeName;
                    processSubModeRequest(triggerModeName, subModeRequest.eventType, subModeRequest);
                }
                else {
                    console.warn("Mode name not found in subModeRequest at event type ", subModeRequest.eventType, " for mode ", subModeRequest);
                    showToast("warn", "Warning", "Mode name not found in subModeRequest");
                    return;
                }
            }
            else if (subModeRequest.eventType === "nextMode") {
                if (subModeRequest.nextMode.modeName.length > 0) {
                    triggerModeName = subModeRequest.nextMode.modeName;
                    processSubModeRequest(triggerModeName, subModeRequest.eventType, subModeRequest);
                }
                else {
                    console.warn("Mode name not found in subModeRequest at event type ", subModeRequest.eventType, " for mode ", subModeRequest);
                    showToast("warn", "Warning", "Mode name not found in subModeRequest");
                    return;
                }
            }
        });
        unsubscribers.push(subModeTriggerUnsubscribe);
        return () => {
            unsubscribers.forEach((unsubscribe) => unsubscribe());
        };
    }, [mfApi]);
    useEffect(() => {
        if (remoteLoadedInfo?.modeName === pendingArtifactData?.modeName &&
            remoteLoadedInfo?.isLoaded &&
            pendingArtifactData &&
            mfApi) {
            console.log("Remote now loaded, dispatching pending artifact data");
            mfApi.dispatch(MF_EVENTS.SEND_ARTIFACT_DATA, pendingArtifactData);
            // Updating artifact ID in URL
            if (pendingArtifactData) {
                console.log("updating artifact ID in URL from pending artifact data", pendingArtifactData);
                updateArtifactIdInUrl(pendingArtifactData, searchParams, setSearchParams);
            }
            setPendingArtifactData(null);
        }
    }, [remoteLoadedInfo, pendingArtifactData, mfApi]);
    // useEffect for user data
    useEffect(() => {
        if (remoteLoadedInfo?.modeName === pendingUserData?.modeName &&
            remoteLoadedInfo?.isLoaded &&
            pendingUserData &&
            mfApi) {
            console.log("Remote now loaded, dispatching pending user data");
            // Updating artifact ID in URL
            if (pendingUserData.userData) {
                mfApi.dispatch(MF_EVENTS.RECEIVE_USER_DETAILS, pendingUserData.userData);
                setPendingUserData({ modeName: "", userData: null });
            }
            else {
                console.warn("Didnt have user data");
                showToast("warn", "Warning", "Didnt have user data");
                return;
            }
        }
    }, [remoteLoadedInfo, pendingUserData, mfApi]);
    useEffect(() => {
        if (hostLoadedInfo?.modeName === pendingArtifactDataFromHost?.modeName &&
            hostLoadedInfo?.isLoaded &&
            pendingArtifactDataFromHost &&
            mfApi) {
            console.log("Host now loaded, dispatching pending artifact data");
            mfApi.dispatch(MF_EVENTS.SEND_ARTIFACT_DATA, pendingArtifactDataFromHost);
            // Updating artifact ID in URL
            if (pendingArtifactDataFromHost) {
                console.log("updating artifact ID in URL from pending artifact data", pendingArtifactDataFromHost);
                updateArtifactIdInUrl(pendingArtifactDataFromHost, searchParams, setSearchParams);
            }
            setPendingArtifactDataFromHost(null);
        }
    }, [hostLoadedInfo, pendingArtifactDataFromHost, mfApi]);
    useEffect(() => {
        if (pendingSubModeData) {
            console.log("called pending sub mode data useEffect");
            const triggerModeName = pendingSubModeData.modeName;
            if (isHostMode(triggerModeName)) {
                if (hostLoadedInfo?.modeName === triggerModeName &&
                    hostLoadedInfo?.isLoaded &&
                    pendingSubModeData.data &&
                    mfApi) {
                    console.log("Host now loaded, dispatching pending sub mode data");
                    mfApi.dispatch(MF_EVENTS.TRANSFER_SUBMODE_REQUEST, pendingSubModeData);
                    if (pendingSubModeData.eventType === "previousMode" && pendingSubModeData.data.previousMode.artifactData && pendingSubModeData.data.previousMode.artifactData.id) {
                        const urlObject = new URL(window.location.href);
                        // then update the artifact in the url as well
                        updateArtifactIdInUrl(pendingSubModeData.data.previousMode.artifactData, urlObject.searchParams, setSearchParams);
                    }
                    setPendingSubModeData(null);
                }
            }
            else {
                if (remoteLoadedInfo?.modeName === triggerModeName &&
                    remoteLoadedInfo?.isLoaded &&
                    pendingSubModeData.data &&
                    mfApi) {
                    console.log("Remote now loaded, dispatching pending sub mode data");
                    mfApi.dispatch(MF_EVENTS.TRANSFER_SUBMODE_REQUEST, pendingSubModeData);
                    if (pendingSubModeData.eventType === "previousMode" && pendingSubModeData.data.previousMode.artifactData && pendingSubModeData.data.previousMode.artifactData.id) {
                        const urlObject = new URL(window.location.href);
                        // then update the artifact in the url as well
                        updateArtifactIdInUrl(pendingSubModeData.data.previousMode.artifactData, urlObject.searchParams, setSearchParams);
                    }
                    setPendingSubModeData(null);
                }
            }
        }
    }, [mfApi, pendingSubModeData, hostLoadedInfo, remoteLoadedInfo]);
    useEffect(() => {
        if (modesHistory.length > 0) {
            const lastMode = modesHistory[modesHistory.length - 1].mode;
            if (lastMode === undefined)
                return;
            if (lastMode === HOST_MODES["Mode Onboarding"] ||
                lastMode === HOST_MODES["Project Mode"] ||
                lastMode === HOST_MODES["Drive Mode"] ||
                lastMode === HOST_MODES["Jira Mode"] ||
                lastMode === HOST_MODES["Email Mode"] ||
                lastMode === "") {
                // console.log("Setting setRemoteLoadedInfo to false");
                setRemoteLoadedInfo({ modeName: "", isLoaded: false });
                setActiveMode("");
                // old code
                // setIsRemoteLoaded(false);
            }
            else {
                // console.log("Setting setHostLoadedInfo to false");
                setHostLoadedInfo({ modeName: "", isLoaded: false });
                setCurrentHostMode("");
                // old code
                // setIsHostLoaded(false);
            }
        }
    }, [modesHistory]);
};
